import type { TemplateFunction, TemplateResult } from 'Components/types';

import EmptyDropdown, { type EmptyDropdownTemplateParams } from './emptyDropdown';
import ListDropdown, { type ListDropdownTemplateParams } from './listDropdown';
import VehicleDropdowns, {
  GarageVehicleWidget,
  type VehicleDropdownsParams,
  type VehicleDropdownsTemplateParams,
} from './vehicleDropdowns';

interface Props {
  template: TemplateFunction<BaseDropdownTemplateParams>;
  closeGarage: () => void;
  doNotRedirectOnVehicleSelect?: boolean;
  isAutoVehicleSelectionDisabled: boolean;
  isDropdownVisible: boolean;
  isEmpty: boolean;
  isShowVehicleDropdowns: boolean;
  isVehicleSelected: boolean;
  redirectUrl?: string;
  showVehicleDropdowns: () => void;
  useNativeDropdown?: boolean;
  vehicle: Record<string, string>;
}

export type BaseDropdownTemplateParams =
  | EmptyDropdownTemplateParams
  | ListDropdownTemplateParams
  | VehicleDropdownsTemplateParams;

export default function BaseDropdown({
  template,
  closeGarage,
  doNotRedirectOnVehicleSelect,
  isAutoVehicleSelectionDisabled,
  isDropdownVisible,
  isEmpty,
  isShowVehicleDropdowns,
  isVehicleSelected,
  redirectUrl,
  showVehicleDropdowns,
  useNativeDropdown,
  vehicle,
}: Props): TemplateResult {
  const vehicleWidget = (templ: TemplateFunction<VehicleDropdownsParams>): TemplateResult =>
    isDropdownVisible ? (
      <GarageVehicleWidget
        isAutoVehicleSelectionDisabled={isAutoVehicleSelectionDisabled}
        doNotRedirectOnVehicleSelect={doNotRedirectOnVehicleSelect}
        redirectUrl={redirectUrl}
        useNativeDropdown={useNativeDropdown}
        onSelectVehicle={closeGarage}
        template={templ}
        key={isShowVehicleDropdowns ? 'add' : isEmpty ? 'empty' : 'list'}
      />
    ) : null;

  if (isShowVehicleDropdowns) {
    return <VehicleDropdowns closeGarage={closeGarage} vehicleWidget={vehicleWidget} template={template} />;
  }

  if (isEmpty) {
    return (
      <EmptyDropdown
        closeGarage={closeGarage}
        vehicleWidget={vehicleWidget}
        showVehicleDropdowns={showVehicleDropdowns}
        template={template}
      />
    );
  }

  return (
    <ListDropdown
      closeGarage={closeGarage}
      vehicleWidget={vehicleWidget}
      doNotRedirectOnVehicleSelect={doNotRedirectOnVehicleSelect}
      redirectUrl={redirectUrl}
      isVehicleSelected={isVehicleSelected}
      showVehicleDropdowns={showVehicleDropdowns}
      vehicle={vehicle}
      template={template}
    />
  );
}
